import React, { useState } from 'react';
import { MotionConfig } from 'framer-motion';
import { QuoteEmail } from './components/quote/QuoteEmail';
import { EditorPanel } from './components/editor/EditorPanel';
import { Switch } from './components/Switch';
import { ExampleBadge } from './components/ExampleBadge';
export function App() {
  const [compare, setCompare] = useState(false);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2rkx4ngpoehnj">
      <div className="min-h-screen w-full bg-canvas font-sans text-navy" data-id="element-1" data-mp="2rlyqmg88cok1">
        <div className="mx-auto max-w-[1280px] px-4 py-8 sm:px-6 lg:px-8 lg:py-12" data-id="element-2" data-mp="2mmcde6sej8b8">
          <header className="mb-6 flex flex-wrap items-end justify-between gap-4" data-id="element-3" data-mp="31aqhel1k12td">
            <div data-id="element-4" data-mp="31cjo20c63n1d">
              <div className="flex items-center gap-2" data-id="element-5" data-mp="2wka1mua9h53u">
                <p className="text-sm font-bold text-navy-500" data-id="element-6" data-mp="2wip5x1c7ng4e">Email template preview</p>
                <ExampleBadge data-id="element-7" data-mp="28suu8n3mnxlq" />
              </div>
              <h1 className="mt-1 text-2xl font-black tracking-tight sm:text-3xl" data-id="element-8" data-mp="23vkvggucm9l8">Purchase quote</h1>
            </div>
            <div className="rounded-full bg-white px-4 py-2 shadow-bubble" data-id="element-9" data-mp="3ikr0s4yore8d">
              <Switch checked={compare} onChange={setCompare} label="Show two scenarios" data-id="element-10" data-mp="3mlawd43m29se" />
            </div>
          </header>

          <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_360px] lg:items-start" data-id="element-11" data-mp="3rbzq6q2rjiup">
            <main className="min-w-0" data-id="element-12" data-mp="6htjo98ovic">
              <QuoteEmail compare={compare} data-id="element-13" data-mp="56nfhsbnbo2" />
            </main>
            <aside className="lg:sticky lg:top-6" data-id="element-14" data-mp="2zlv7qwykd5w4">
              <EditorPanel compare={compare} onCompareChange={setCompare} data-id="element-15" data-mp="2zn66ujh2dpgw" />
            </aside>
          </div>
        </div>
      </div>
    </MotionConfig>;
}